import { Component, OnInit } from '@angular/core';
import {DynamicDialogRef} from 'primeng/api';
import {DynamicDialogConfig} from 'primeng/api';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-multipleaddress',
  templateUrl: './multipleaddress.component.html',
  styleUrls: ['./multipleaddress.component.css']
})
export class MultipleaddressComponent implements OnInit {
  selectedAddressId: any;

  constructor(private messageService: MessageService, public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }
  recordList: any = [];
  ngOnInit() {
    this.recordList = this.config.data.addressList;
  }

  continueExsisting() {
    if(this.selectedAddressId != undefined && this.selectedAddressId >= 0) {
      var address = this.recordList.filter(proj => proj.sequence === this.selectedAddressId);
      this.ref.close(address[0]);
    } else {
      this.messageService.add({ severity: 'info', summary: 'Business Address', detail: "Select Address" });
    }
  }

  ignore() {
    this.ref.close(true);
  }

  close() {
    this.ref.close(false);
  }

}
